module.exports = require("seedrandom");